export default __webpack_public_path__ + "static/media/stethoscope.d34f33ae.svg";